import { inject, Injectable } from '@angular/core';
import { API_CONFIG, ApiCallingV2Service } from '@zayan-erp/shared';
import { Observable } from 'rxjs';
import { SalesJobType } from '../models/sales-type.model';
@Injectable({
  providedIn: 'root'
})
export class SalesJobTypeService {
  #http = inject(ApiCallingV2Service);
  #apiConfig = inject(API_CONFIG);
  baseUrl = this.#apiConfig.baseUrlV2;

  readSalesJobTypes(salesTypeId: string): Observable<SalesJobType[]> {
    return this.#http.getData(`${this.baseUrl}/SalesType/${salesTypeId}/jobtypes?status=true`, {
      showLoader: true,
      showMessage: false
    });
  }

  createSalesJobType(salesTypeId: string, salesJobType: SalesJobType): Observable<SalesJobType> {
    return this.#http.postData(
      `${this.baseUrl}/SalesType/${salesTypeId}/jobtypes`,
      { showLoader: true, showMessage: true },
      salesJobType
    );
  }

  updateSalesJobType(salesTypeId: string, id: string, salesJobType: SalesJobType): Observable<SalesJobType> {
    return this.#http.putData(`${this.baseUrl}/SalesType/${salesTypeId}/jobtypes/${id}`, salesJobType, {
      showLoader: true,
      showMessage: true
    });
  }

  deleteSalesJobType(salesTypeId: string, id: string): Observable<unknown> {
    return this.#http.deleteData(`${this.baseUrl}/SalesType/${salesTypeId}/jobtypes/${id}`, {
      showLoader: true,
      showMessage: true
    });
  }
  getSalesJobTypeById(id: string): Observable<SalesJobType> {
    return this.#http.getData(`${this.baseUrl}/SalesType/salestypesjobtypes/${id}`, {
      showLoader: true,
      showMessage: false
    });
  }
}
